import { TableDisplayDataAction, REPLACE_TABLE_DISPLAY_DATA } from ".";
import { TableRowData } from "non-ui/data";

export function replaceTableDisplayData(tabledisplaydata: TableRowData[]) : TableDisplayDataAction {
	return {
		type: REPLACE_TABLE_DISPLAY_DATA,
		payload: tabledisplaydata
	};
} 
